import post from './post.js';
import get from './get.js';

export default {
	data: ({session}) => get('420/data',{session}),
	delete: ({ session, ip, name }) => post('420/delete', { session, ip, name }),
	delete_all: ({ session, ip }) => post('420/delete_all', { session, ip }),
	masterpieces: ({ session, ip, masterpieces }) => post('420/masterpieces', { session, ip, masterpieces })
};
